module.exports = __webpack_public_path__ + "img/reportes_mobile.80594ca9.svg";